import goTo from 'vuetify/lib/services/goto'
import {toLocaleUpperCase} from '@/app-core/lib/helpers'
import Translatable from '@/app-core/mixins/translatable'

export default {
  name      : 'StoreCatalogToolbar',
  components: {},
  directives: {},
  mixins    : [Translatable],
  props     : {},
  dataStore : {
    StoreMenu: 'Store.Menu',
    StoreInfo: 'Store.Info'
  },
  data() {
    return {
      scrolling  : false,
      selectedTab: null
    }
  },
  computed: {
    StoreMenuCategories() {
      const activeStoreId = this.$route.params?.id || null
      const store = this.StoreMenu[activeStoreId]

      return store ? store.categories : []
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
    this.$bus.$on('category:select', this.onCategorySelect)
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
    this.$bus.$off('category:select', this.onCategorySelect)
  },
  destroyed() {
  },
  methods: {
    toLocaleUpperCase,
    onSelectShopClick() {
      this.$bus.$emit('show:select-store')
    },

    onCategoryClick(category) {
      this.scrolling = true

      goTo(`#tab-${this.getTranslatedField(category, 'Slug')}`, {
        offset  : 65,
        duration: 500
      }).then(() => {
        setTimeout(() => {
          this.scrolling = false
        }, 100)
      })
    },

    onCategorySelect(tabId) {
      if (this.scrolling) return

      this.selectedTab = tabId
    }
  }
}
